var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.alerts && _vm.alerts.length)?_c('div',{staticClass:"energy-label-alert-notice"},_vm._l((_vm.alerts),function(alert){return _c('span',{key:alert.type,staticClass:"badge badge-warning energy-label-alert-notice__badge"},[_vm._v(_vm._s(alert.message))])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }